import { z } from 'zod'

export const WORK_TASK_TRACKER_WATCHER_LINK_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerWatcherLinkResponseSchema = z.unknown()
export type WorkTaskTrackerWatcherLinkResponse = z.infer<typeof workTaskTrackerWatcherLinkResponseSchema>
